import React from "react";

const IsSmoke = (props) => {

    const handleChewChange = (value) => {
        props.IsTobaco(value);
    };

    return (
        <div className="chew_tobacoPOP">
           {/* <button type="button" className="clsBtn" data-dismiss="modal">
                <img src={require("../Investment/Cross.svg").default} alt="" />
            </button>*/}
            <div className="inner_box_tobaco">
                <div>
                    <p>Just one more thing...</p>
                    <hr className="mt-0" />
                </div>
                <div>
                    <h6>Do you use tobacco products, such as smoking or chewing?</h6>
                    <small>Select 'Yes' if you have used tobacco products, including smoking or chewing, in last 1 year.</small>
                    <div>
                        <label>
                            <button
                                type="radio"
                                className=""
                                onClick={() => handleChewChange(true)}
                            >
                                <span>Yes</span>
                            </button>
                        </label>
                        <label>
                            <button
                                type="button"
                                className=""
                                onClick={() => handleChewChange(false)}
                            >
                                <span>No</span>
                            </button>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IsSmoke;

